module.exports = __webpack_public_path__ + "img/arrow-grey.7c6d4d72.svg";